"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/People/RemoveFromAccountModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _noticeBar = require('web/services/context/noticeBar');
var _people = require('./people');









// The server's reason, when it gave one people can read.
const refusal = (e) => {
  const text = String(_nullishCoalesce(_optionalChain([(e ), 'optionalAccess', _ => _.Error]), () => ( '')))
  return text && !text.includes('\n') && text.length < 200 ? text : null
}

/* Remove from account (D-125, D-127): every membership the person has in
 * the account's organizations, all or nothing. When that would delete their
 * user, the server says so before changing anything, and the dialog asks
 * again with the E-37 wording. */
const RemoveFromAccountModal = ({ orgKey, person, orgName, onClose, onRemoved }) => {
  const [isDeleting, setIsDeleting] = _react.useState.call(void 0, false)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [error, setError] = _react.useState(null)
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  const name = _people.personName.call(void 0, person)
  const orgs = person.Memberships.map(m => orgName(m.OrgKey)).join(', ')

  const remove = () => {
    setIsSaving(true)
    setError(null)
    _actions2.default.removeFromAccount({ OrgKey: orgKey, UserKey: person.UserKey, ConfirmDeleteUser: isDeleting })
      .then(r => {
        showSuccessBar(r.DeletedUser ? `Removed ${name} and deleted their BloomText user` : `Removed ${name} from the account`)
        onRemoved()
      })
      .catch(e => {
        setIsSaving(false)
        if (_useOrgAccount.isConfirmDeleteUserError.call(void 0, e)) setIsDeleting(true)
        else setError(_nullishCoalesce(refusal(e), () => ( `Couldn't remove ${name}. Nothing was changed.`)))
      })
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, onClose: onClose, title: `Remove ${name} from the account?`, className: "account-remove-modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
      ,  isDeleting
        ? (
          _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "These are their only organizations, so this deletes their BloomText user. They won't be able to sign in. This can't be undone."


          )
          )
        : (
          _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "They leave every organization on the account: "
                   ,  orgs , ". They lose access to those organizations' chats and patients."

          )
          )
      ,  error && _react2.default.createElement('p', { className: "account-remove-modal--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  error ) 
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnTheme: "danger",
        primaryBtnLabel: isDeleting ? _useOrgAccount.REMOVE_AND_DELETE_USER_LABEL : 'Remove from account',
        isPrimaryLoading: isSaving,
        onPrimaryBtnClick: remove,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
      )
    )
  )
}

exports. default = RemoveFromAccountModal
